module.exports = __webpack_public_path__ + "img/konami.1badfe5a.jpeg";